import { ValidatorFn, AbstractControl, ValidationErrors, FormArray } from "@angular/forms";

export function uniqueIdRequirement(array: FormArray): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!array) return null; // project is not defined yet
        const nonunique = array.controls.some((c: AbstractControl) => c.value.id === control.value);
        return nonunique ? { nonunique: true } : null;
    };
}
